import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import {
  checkEmailValid,
  checkPhoneValid,
} from '../../../../helpers/validation'
import { selectUserProfile } from '../../../category/store/slice'
import { getUserProfileThunk } from '../../../category/store/thunk'
import { Input } from '../../../html/input'
import { InputTextArea } from '../../../html/input/InputTextArea'
import { PopupAction } from '../../../popup/PopupAction'
import { FORM_FIELD_KEY } from '../constants'
import { postCategoryContactUs } from './thunk'

export const PopupContactUs = ({ isOpen, onClose }) => {
  const dispatch = useDispatch()
  const userProfile = useSelector(selectUserProfile)

  const [form, setForm] = useState({})
  const [isValid, setIsValid] = useState({ phone: true, email: true })

  useEffect(() => {
    setForm({
      [FORM_FIELD_KEY.NAME]: userProfile?.fullName,
      [FORM_FIELD_KEY.EMAIL]: userProfile?.email,
      [FORM_FIELD_KEY.PHONE]: userProfile?.companyPhone,
    })
  }, [userProfile])

  const onSubmit = () => {
    setIsValid({
      phone: checkPhoneValid(form.customerPhone),
      email: checkEmailValid(form.customerEmail),
    })

    if (
      checkPhoneValid(form.customerPhone) &&
      checkEmailValid(form.customerEmail)
    ) {
      dispatch(postCategoryContactUs(form))
      onHandleClose()
    }
  }

  const onCancel = () => {
    onHandleClose()
  }

  const onHandleClose = () => {
    onClose()
    setForm({
      [FORM_FIELD_KEY.NAME]: userProfile?.fullName,
      [FORM_FIELD_KEY.EMAIL]: userProfile?.email,
      [FORM_FIELD_KEY.PHONE]: userProfile?.companyPhone,
    })
    setIsValid({ phone: true, email: true })
  }

  const onChange = (key, event) => {
    const eventValue = event.target.value

    if (key === FORM_FIELD_KEY.PHONE) {
      let value = ''
      const regex = /^\+?[0-9]*$/g

      if (!eventValue || eventValue.match(regex)) {
        value = eventValue
      }

      if (!eventValue.match(regex)) {
        value = form[FORM_FIELD_KEY.PHONE] || ''
      }

      setIsValid({
        ...isValid,
        phone: checkPhoneValid(value),
      })
      setForm({ ...form, [key]: value })
    } else if (key === FORM_FIELD_KEY.EMAIL) {
      setIsValid({
        ...isValid,
        email: checkEmailValid(eventValue, true),
      })
      setForm({ ...form, [key]: eventValue })
    } else {
      setForm({ ...form, [key]: eventValue })
    }
  }

  useEffect(() => {
    if (!Object.keys(userProfile).length) {
      dispatch(getUserProfileThunk())
    }
  }, [])

  return (
    <>
      <PopupAction
        title="domesticSearchPreview.CONTACT_US"
        isShow={isOpen}
        handleClose={onHandleClose}
        btnSubmit={{
          label: 'domesticSearchPreview.SUBMIT',
          event: onSubmit,
          isI18n: true,
        }}
        btnCancel={{
          label: 'domesticSearchPreview.CANCEL',
          event: onCancel,
          isI18n: true,
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <Translate value="domesticSearchPreview.LEAVE_US_A_MESSAGE_TO_CONTACT" />
        </div>

        <div className="flexColumn" style={{ gap: 29 }}>
          <Input
            isShowLabel
            isShowIcon={false}
            placeHolder="domesticSearchPreview.FULL_NAME"
            defaultValue={form[FORM_FIELD_KEY.NAME]}
            onChange={(e) => onChange(FORM_FIELD_KEY.NAME, e)}
          />
          <Input
            isShowLabel
            isShowIcon={false}
            isValid={isValid.email}
            placeHolder="domesticSearchPreview.EMAIL"
            defaultValue={form[FORM_FIELD_KEY.EMAIL]}
            textInvalid={
              typeof form.customerEmail === 'string' &&
              !!form.customerEmail.trim()
                ? 'domesticSearchPreview.INVALID_EMAIL'
                : 'domesticSearchPreview.REQUIRED_FIELD'
            }
            onChange={(e) => onChange(FORM_FIELD_KEY.EMAIL, e)}
          />
          <Input
            value={form[FORM_FIELD_KEY.PHONE]}
            isShowLabel
            isShowIcon={false}
            isValid={isValid.phone}
            placeHolder="domesticSearchPreview.PHONE_NUMBER"
            defaultValue={form[FORM_FIELD_KEY.PHONE]}
            textInvalid={
              typeof form.customerPhone === 'string' &&
              !!form.customerPhone.trim()
                ? 'domesticSearchPreview.INVALID_PHONE'
                : 'domesticSearchPreview.REQUIRED_FIELD'
            }
            onChange={(e) => onChange(FORM_FIELD_KEY.PHONE, e)}
          />
          <InputTextArea
            isShowLabel
            placeHolder="domesticSearchPreview.LEAVE_US_A_MESSAGE"
            rows={8}
            onChange={(e) => onChange(FORM_FIELD_KEY.NOTE, e)}
          />
        </div>
      </PopupAction>
    </>
  )
}
